import { cn } from '@/lib/utils';
import ColorCardSkeleton from './ColorCardSkeleton';
import ColorPickerSkeleton from './ColorPickerSkeleton';

interface PageSkeletonProps {
  className?: string;
}

const PageSkeleton = ({ className }: PageSkeletonProps) => {
  return (
    <div className={cn('min-h-screen p-6 bg-gradient-to-b from-background/80 to-muted/20', className)}>
      <div className="max-w-4xl mx-auto space-y-8">
        <div className="space-y-4">
          <div className="h-10 w-64 bg-muted/50 rounded animate-pulse mx-auto" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-[1fr,300px] gap-8">
          <div className="space-y-8">
            <ColorCardSkeleton />
            <ColorPickerSkeleton />
          </div>

          <div className="h-[300px] backdrop-blur-sm bg-white/5 rounded-xl border border-white/10 p-6">
            <div className="space-y-4">
              <div className="h-6 w-32 bg-muted/50 rounded animate-pulse" />
              <div className="h-10 bg-muted/50 rounded animate-pulse" />
              <div className="h-6 w-32 bg-muted/50 rounded animate-pulse" />
              <div className="h-10 bg-muted/50 rounded animate-pulse" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageSkeleton;